import { Button } from "@mui/material";
import React, { useContext } from "react";

import { useTranslation } from "react-i18next";
import AppContext from "../../../../Contexts/AppContext";
import WrongLocationIcon from "@mui/icons-material/WrongLocation";

export const ExitPhotointerpretationModeButton = () => {
  const { t } = useTranslation("main");
  const { modeOptions, resetModeOptions } = useContext(AppContext);

  const handleExitEditMode = async () => {
    resetModeOptions();
  };

  return (
    <Button
      sx={{
        display: modeOptions.ASBESTOS_CLICK.length > 0 ? "" : "none",
        opacity: 0.7,
        "&:hover": {
          opacity: 1,
        },
      }}
      onClick={handleExitEditMode}
      className="mapButton"
      endIcon={<WrongLocationIcon />}
      color="error"
      variant="contained"
    >
      {t("exit_edition")}
    </Button>
  );
};
